import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icons-16-line-list",
  "use": "icon-icons-16-line-list-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icons-16-line-list\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M13 12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2h7zM2 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm11-5a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2h7zM2 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm11-5a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2h7zM2 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2z\" fill=\"#4C556C\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol